module.exports = __webpack_public_path__ + "img/D202212_3.17bc645f.jpg";